import React from 'react';
import 'react-mdl/extra/material.js';
import {Textfield} from 'react-mdl';

class SMMailConfirmationView extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      email: this.props.email,
      error_message: this.props.error_message,
      authenticity_token: this.props.authenticity_token,
      check_messages: this.props.check_messages,
    };
    
    this.renderMessage =  this.renderMessage.bind(this);
  }

  componentDidMount() {
  }
  
  renderMessage() {
    let errorMessage = this.state.error_message;
    let email = this.state.email;
    let regAgainMail = new RegExp(this.state.check_messages['confirmation_instructions']);
    let regAlreadyRegistered = new RegExp(this.state.check_messages['already_confirmed']);
    let regInvalidToken = new RegExp(this.state.check_messages['expired']);
    
    if(errorMessage['email'] && regAgainMail.test(errorMessage['email'])) 
    {
      return (
        <div className="signup-box__wrapper">
          <p className="signup-box__notes ta-c">{I18n.t("service.text_000018")}<br />{I18n.t("service.text_000019")}
          </p>
          <div className="signup-box__mailcheck">
            <p><span className="sm-signup-box__mailcheck__title">{I18n.t("service.label_000500")}：</span>{email}</p>
          </div>
          <form action="/i/confirmation" acceptCharset="UTF-8" method="post">
            <input type="hidden" name='authenticity_token' value={this.state.authenticity_token} />
            <input type="email" value={email} name="user[email]" id="user_email" hidden />
            <p className="signup-box__notes ta-c">
              <input type="submit" value={I18n.t("service.label_000091")} name="commit"
                     className="button-blue pt15 pb15 w200 sm-w100" />
            </p>
          </form>
        </div>
      );
    } else if (errorMessage['email'] && regAlreadyRegistered.test(errorMessage['email'])) {
      return(
        <div className="signup-box__wrapper">
          <p className="signup-box__notes ta-c">{I18n.t("service.text_000020")}
          </p>
          <div className="signup-box__mailcheck">
            <p><span className="sm-signup-box__mailcheck__title">{I18n.t("service.label_000500")}：</span>{email}</p>
          </div>
        </div>
      );
    } else if (errorMessage['confirmation_token'] && regInvalidToken.test(errorMessage['confirmation_token'])) {
      return(
        <div className="signup-box__wrapper">
          <p className="signup-box__notes ta-c">{I18n.t("service.text_000023")}
          </p>
        </div>
      );
    } else {
      
      let message = '';
      if(errorMessage['email']){
        message = (
          <p className="signup-box__required"><i className="fa fa-exclamation-circle" />
            {I18n.t("service.label_000500") + errorMessage['email'][0]}
          </p>
        );
      }
      
      return(
        <div>
          <div className="signup-box__wrapper">
            <p className="signup-box__notes ta-c" dangerouslySetInnerHTML={{__html: I18n.t("service.text_000024")}} />
          </div>
          <div className="signup-box__wrapper-form">
            <form action="/i/confirmation" acceptCharset="UTF-8" method="post">
              <div className="row signup-box__md-top">
                <div className="col-sm-12 mt20">
                  <input name="utf8" type="hidden" value="✓" />
                  <input type="hidden" name='authenticity_token' value={this.state.authenticity_token} />
                  <Textfield
                    className="w100pa"
                    id="mail"
                    name="user[email]"
                    label={I18n.t("service.label_000500")}
                    floatingLabel
                  />
                  {message}
                </div>
              </div>
              <div className="col-xs-12 ta-c mt20">
                <input type="submit" name="commit" value={I18n.t("service.label_000103")} className="button-blue pt15 pb15 w200 sm-w100" />
              </div>
            </form>
          </div>
        </div>
      );
    }
  }

  render() {
    return (
      <div className="site-main">
        <div className="page__even lp-page__padding">
          <div className="page__col1">
            <div className="signup-head">
              <h1 className="page-title">{I18n.t("service.label_000092")}</h1>
              <ul className="signup-step mb20">
                <li className="signup-step__status1">{I18n.t("service.label_000027")}</li>
                <li className="signup-step__status3">{I18n.t("service.label_000099")}</li>
                <li className="signup-step__status2 is-current"><span className="sm-hide">{I18n.t("service.label_000081")}</span>{I18n.t("service.label_000082")}</li>
              </ul>
            </div>
            <div className="signup-box">
              <div className="row">
                <div className="col-xs-12">
                  {this.renderMessage()}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default SMMailConfirmationView;



// WEBPACK FOOTER //
// ./app/javascript/components/sessions/SMMailConfirmationView.jsx